<template>
    <t-input-select
    inputClass="symboleOut"
    v-model="currency"
    :options="$store.getters.currencies"
    :optionLabel="'symbol'"
    :optionValue="'id'"
    name="currecny"
    :placeholder="'Select currency'"
    @update:modelValue="changeCurrency"
    :style ="style"

    />
</template>

<script>
import TInputSelect from '../../../common/components/input-text/TInputSelect.vue';
import {getCurrencies} from "../../../common/api/currencies";
import { SET_CURRENCIES, SET_CURRENCY } from '../../../common/store/actions';

export default {
  components: { TInputSelect },
  props:{
    style:{}
  },
  data() {
    return {
      currency:this.$store.getters.currency.id
    };
  },
  methods:
  {
    changeCurrency(target)
    {
      let that = this
      getCurrencies().then((resp) => {
        that.$store.commit(SET_CURRENCIES, resp.data.data);
        if (that.$store.getters.currency == undefined)
          that.$store.dispatch(SET_CURRENCY, that.$store.getters.currencies[0]);
        if(localStorage.getItem("currency"))
        {
          let currentCurrency = JSON.parse(localStorage.getItem("currency"))
          for(let i = 0; i<that.$store.getters.currencies.length; i++ )
          {
            if (currentCurrency.id == that.$store.getters.currencies[i].id)
            {
              that.$store.dispatch(SET_CURRENCY, that.$store.getters.currencies[i]);
            }
          }
        }
        
        let currency = null
        let currencies = that.$store.getters.currencies
        for(let i =0; i < currencies.length; i++)
        {
            if(currencies[i].id == target)
                currency = currencies[i]
        }
        that.$store.commit('setNegotiationCurrency',currency)  
      });

    }
  },
  mounted() {
    let that = this
    getCurrencies().then((resp) => {
      that.$store.commit(SET_CURRENCIES, resp.data.data);
      if (that.$store.getters.currency == undefined)
        that.$store.dispatch(SET_CURRENCY, that.$store.getters.currencies[0]);
      if(localStorage.getItem("currency"))
      {
        let currentCurrency = JSON.parse(localStorage.getItem("currency"))
        for(let i = 0; i<that.$store.getters.currencies.length; i++ )
        {
          if (currentCurrency.id == that.$store.getters.currencies[i].id)
          {
            that.$store.dispatch(SET_CURRENCY, that.$store.getters.currencies[i]);
          }
        }
      }
      that.currency = that.$store.getters.currency.id
      that.$store.commit('setNegotiationCurrency',that.$store.getters.currency)   
    });
    
  },
};
</script>


<style lang="scss" scoped>
 :deep(.p-dropdown){
   // height: 31px !important;
    line-height: 0;
 }
</style>